import { render, staticRenderFns } from "./InvoiceItemsEdit.vue?vue&type=template&id=0874135a&scoped=true"
import script from "./InvoiceItemsEdit.vue?vue&type=script&lang=js"
export * from "./InvoiceItemsEdit.vue?vue&type=script&lang=js"
import style0 from "./InvoiceItemsEdit.vue?vue&type=style&index=0&id=0874135a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0874135a",
  null
  
)

export default component.exports